import { Button, Modal, useFetch } from "@4uhub/lib4uhub";
import { Box, Typography } from "@mui/material";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { IDashBoardPanel } from "../../../../../../../../models/dashboardpanel";
import MainApiService from "../../../../../../../../services/mainApi.service";
import { useDashboardView } from "../../../../../../../../store/contexts/DashBoardViewContext";

const DASHBOARD_VIEW_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/DashboardPanel/";

const dashboardViewService = new MainApiService<IDashBoardPanel>(
  DASHBOARD_VIEW_ROUTE
);

const TRANSLATION_PATH = "page.panels.";

interface IDeleteModalProps {
  id: string;
  openModal: boolean;
  closeModalHandler: () => void;
}

export const DeleteModal = memo(
  ({ id, openModal, closeModalHandler }: IDeleteModalProps) => {
    const { t } = useTranslation();

    const { setDashboards } = useDashboardView();

    const { sendRequest, loading } = useFetch(
      dashboardViewService.deleteItemById
    );

    const deleteHandler = useCallback(async () => {
      const { data, success } = await sendRequest(id);
      if (data && success) {
        closeModalHandler();
        setDashboards((prev) => prev.filter((item) => item.id !== id));
      }
    }, [id, sendRequest, setDashboards, closeModalHandler]);

    return (
      <Modal
        open={openModal}
        onClose={closeModalHandler}
        title={`${t(TRANSLATION_PATH + "confirm.title")}`}
      >
        <Typography
          sx={(t) => ({
            color: t.palette.grey[t.palette.mode === "light" ? 600 : 400],
          })}
        >
          {t(TRANSLATION_PATH + "confirm.description")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "end",
            gap: 1,
          }}
        >
          <Button
            variant="outlined"
            disabled={loading}
            onClick={closeModalHandler}
          >
            {t(TRANSLATION_PATH + "cancel_button")}
          </Button>
          <Button variant="contained" loading={loading} onClick={deleteHandler}>
            {t(TRANSLATION_PATH + "confirm_button")}
          </Button>
        </Box>
      </Modal>
    );
  }
);
